import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-account-block-skeleton',
  templateUrl: './account-block-skeleton.component.html',
  styleUrls: ['./account-block-skeleton.component.scss'],
})
export class AccountBlockSkeletonComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
